import { state } from "../state";

/* Class Sedes */
export class SedesPage extends HTMLElement {

    connectedCallback() {
        this.render();
        state.dataSedes();
    }

    render() {
        this.className = 'sedes-page';
        this.innerHTML =
        `
        <div class="page-container">
            <div class="page-body">
                <div class="body-box">
                    <div class="body__cuerpo sedes__info">
                        <div class="sedes__info-text">
                            <h3 class="body__cuerpo-text-title">Sedes y Centro Asociados</h3>
                        </div>
                    </div>
                    <div class="body__cuerpo">
                        <div class="sedes__container">
                            <template class="sedes__template">
                                <div class="sedes__box">
                                    <img class="sedes__photo" src="" alt="sede">
                                    <h2 class="sedes__titulo">Data</h2>
                                    <p class="sedes__direccion">Data</p>
                                    <p class="sedes__phone">Data</p>
                                    <p class="sedes__mail">Data</p>
                                </div>
                            </template>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        `
    }
}

/* Define */
customElements.define("sedes-page", SedesPage)
